module.exports = __webpack_public_path__ + "static/media/chat.e4d7320c.svg";